import styled from 'styled-components';

import { colors } from '../../../styles/constants';

export const FormBuilderCheckboxWrapperErrorMessage = styled.div`
  margin-top: 6px;
  font-size: 14px;
  font-family: Roboto, sans-serif;
  color: ${colors.red};
`;

export const FormBuilderCheckboxWrapper = styled.div`
  margin-bottom: 10px;

  ${({ theme }) => theme.mediaQuery.sm} {
    margin-bottom: 20px;
  }

  label {
    display: flex;
    align-items: center;
  }

  input {
    appearance: none;
    margin-right: 16px;
    margin-left: 0px;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border: 1px solid #cccccc;
    border-radius: 4px;
    position: relative;
    cursor: pointer;

    :checked {
      background-color: #ffffff;
      border-color: #000000;
    }

    :checked::before {
      content: '';
      display: block;
      position: absolute;
      top: 1px;
      left: 0.5px;
      width: 14px;
      height: 14px;
      background-image: url('/assets/images/check-icon.svg');
      background-size: 12px 12px;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
`;
